/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VsLastpassRouteImport } from './routes/vs-lastpass'
import { Route as VsDashlaneRouteImport } from './routes/vs-dashlane'
import { Route as VsBitwardenRouteImport } from './routes/vs-bitwarden'
import { Route as Vs1passwordRouteImport } from './routes/vs-1password'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SuperadminRouteImport } from './routes/superadmin'
import { Route as SecurityRouteImport } from './routes/security'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as InvitationRouteImport } from './routes/invitation'
import { Route as FeaturesRouteImport } from './routes/features'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SuperadminIndexRouteImport } from './routes/superadmin/index'
import { Route as SuperadminUsersRouteImport } from './routes/superadmin/users'
import { Route as SuperadminSystemRouteImport } from './routes/superadmin/system'
import { Route as SuperadminSecurityRouteImport } from './routes/superadmin/security'
import { Route as SuperadminOrganizationsRouteImport } from './routes/superadmin/organizations'
import { Route as SuperadminNotificationsRouteImport } from './routes/superadmin/notifications'
import { Route as SuperadminLegalRouteImport } from './routes/superadmin/legal'
import { Route as SuperadminInvitationsRouteImport } from './routes/superadmin/invitations'
import { Route as SuperadminFeatureFlagsRouteImport } from './routes/superadmin/feature-flags'
import { Route as SuperadminBillingRouteImport } from './routes/superadmin/billing'
import { Route as SuperadminAuditLogsRouteImport } from './routes/superadmin/audit-logs'
import { Route as SuperadminAiImportsRouteImport } from './routes/superadmin/ai-imports'
import { Route as ShareLinkIdRouteImport } from './routes/share.$linkId'
import { Route as InviteTokenRouteImport } from './routes/invite.$token'
import { Route as AppResetPasswordRouteImport } from './routes/_app/reset-password'
import { Route as AppRegisterRouteImport } from './routes/_app/register'
import { Route as AppAuthRouteImport } from './routes/_app/_auth'
import { Route as AppLoginLayoutRouteImport } from './routes/_app/login/_layout'
import { Route as AppAuthDashboardRouteImport } from './routes/_app/_auth/dashboard'
import { Route as AppLoginLayoutIndexRouteImport } from './routes/_app/login/_layout.index'
import { Route as AppAuthDashboardIndexRouteImport } from './routes/_app/_auth/dashboard/index'
import { Route as AppAuthDashboardWatchtowerRouteImport } from './routes/_app/_auth/dashboard/watchtower'
import { Route as AppAuthDashboardVaultRouteImport } from './routes/_app/_auth/dashboard/vault'
import { Route as AppAuthDashboardSettingsRouteImport } from './routes/_app/_auth/dashboard/settings'
import { Route as AppAuthDashboardOrganizationRouteImport } from './routes/_app/_auth/dashboard/organization'
import { Route as AppAuthDashboardGeneratorRouteImport } from './routes/_app/_auth/dashboard/generator'
import { Route as AppAuthDashboardFamilyRouteImport } from './routes/_app/_auth/dashboard/family'
import { Route as AppAuthDashboardSettingsIndexRouteImport } from './routes/_app/_auth/dashboard/settings.index'
import { Route as AppAuthDashboardExtensionsIndexRouteImport } from './routes/_app/_auth/dashboard/extensions/index'
import { Route as AppAuthDashboardSettingsSecurityRouteImport } from './routes/_app/_auth/dashboard/settings/security'
import { Route as AppAuthDashboardSettingsRemindersRouteImport } from './routes/_app/_auth/dashboard/settings/reminders'
import { Route as AppAuthDashboardSettingsProfileRouteImport } from './routes/_app/_auth/dashboard/settings/profile'
import { Route as AppAuthDashboardSettingsPasswordHistoryRouteImport } from './routes/_app/_auth/dashboard/settings/password-history'
import { Route as AppAuthDashboardSettingsImportExportRouteImport } from './routes/_app/_auth/dashboard/settings/import-export'
import { Route as AppAuthDashboardSettingsEmergencyRouteImport } from './routes/_app/_auth/dashboard/settings/emergency'
import { Route as AppAuthDashboardSettingsDataExportRouteImport } from './routes/_app/_auth/dashboard/settings/data-export'
import { Route as AppAuthDashboardSettingsBillingRouteImport } from './routes/_app/_auth/dashboard/settings/billing'
import { Route as AppAuthDashboardExtensionsPairRouteImport } from './routes/_app/_auth/dashboard/extensions/pair'

const VsLastpassRoute = VsLastpassRouteImport.update({
  id: '/vs-lastpass',
  path: '/vs-lastpass',
  getParentRoute: () => rootRouteImport,
} as any)
const VsDashlaneRoute = VsDashlaneRouteImport.update({
  id: '/vs-dashlane',
  path: '/vs-dashlane',
  getParentRoute: () => rootRouteImport,
} as any)
const VsBitwardenRoute = VsBitwardenRouteImport.update({
  id: '/vs-bitwarden',
  path: '/vs-bitwarden',
  getParentRoute: () => rootRouteImport,
} as any)
const Vs1passwordRoute = Vs1passwordRouteImport.update({
  id: '/vs-1password',
  path: '/vs-1password',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const SuperadminRoute = SuperadminRouteImport.update({
  id: '/superadmin',
  path: '/superadmin',
  getParentRoute: () => rootRouteImport,
} as any)
const SecurityRoute = SecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const InvitationRoute = InvitationRouteImport.update({
  id: '/invitation',
  path: '/invitation',
  getParentRoute: () => rootRouteImport,
} as any)
const FeaturesRoute = FeaturesRouteImport.update({
  id: '/features',
  path: '/features',
  getParentRoute: () => rootRouteImport,
} as any)
const FaqRoute = FaqRouteImport.update({
  id: '/faq',
  path: '/faq',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SuperadminIndexRoute = SuperadminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SuperadminRoute,
} as any)
const SuperadminUsersRoute = SuperadminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => SuperadminRoute,
} as any)
const SuperadminSystemRoute = SuperadminSystemRouteImport.update({
  id: '/system',
  path: '/system',
  getParentRoute: () => SuperadminRoute,
} as any)
const SuperadminSecurityRoute = SuperadminSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => SuperadminRoute,
} as any)
const SuperadminOrganizationsRoute = SuperadminOrganizationsRouteImport.update({
  id: '/organizations',
  path: '/organizations',
  getParentRoute: () => SuperadminRoute,
} as any)
const SuperadminNotificationsRoute = SuperadminNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => SuperadminRoute,
} as any)
const SuperadminLegalRoute = SuperadminLegalRouteImport.update({
  id: '/legal',
  path: '/legal',
  getParentRoute: () => SuperadminRoute,
} as any)
const SuperadminInvitationsRoute = SuperadminInvitationsRouteImport.update({
  id: '/invitations',
  path: '/invitations',
  getParentRoute: () => SuperadminRoute,
} as any)
const SuperadminFeatureFlagsRoute = SuperadminFeatureFlagsRouteImport.update({
  id: '/feature-flags',
  path: '/feature-flags',
  getParentRoute: () => SuperadminRoute,
} as any)
const SuperadminBillingRoute = SuperadminBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => SuperadminRoute,
} as any)
const SuperadminAuditLogsRoute = SuperadminAuditLogsRouteImport.update({
  id: '/audit-logs',
  path: '/audit-logs',
  getParentRoute: () => SuperadminRoute,
} as any)
const SuperadminAiImportsRoute = SuperadminAiImportsRouteImport.update({
  id: '/ai-imports',
  path: '/ai-imports',
  getParentRoute: () => SuperadminRoute,
} as any)
const ShareLinkIdRoute = ShareLinkIdRouteImport.update({
  id: '/share/$linkId',
  path: '/share/$linkId',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppResetPasswordRoute = AppResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AppRoute,
} as any)
const AppRegisterRoute = AppRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => AppRoute,
} as any)
const AppAuthRoute = AppAuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => AppRoute,
} as any)
const AppLoginLayoutRoute = AppLoginLayoutRouteImport.update({
  id: '/login/_layout',
  path: '/login',
  getParentRoute: () => AppRoute,
} as any)
const AppAuthDashboardRoute = AppAuthDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppAuthRoute,
} as any)
const AppLoginLayoutIndexRoute = AppLoginLayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppLoginLayoutRoute,
} as any)
const AppAuthDashboardIndexRoute = AppAuthDashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAuthDashboardRoute,
} as any)
const AppAuthDashboardWatchtowerRoute =
  AppAuthDashboardWatchtowerRouteImport.update({
    id: '/watchtower',
    path: '/watchtower',
    getParentRoute: () => AppAuthDashboardRoute,
  } as any)
const AppAuthDashboardVaultRoute = AppAuthDashboardVaultRouteImport.update({
  id: '/vault',
  path: '/vault',
  getParentRoute: () => AppAuthDashboardRoute,
} as any)
const AppAuthDashboardSettingsRoute =
  AppAuthDashboardSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AppAuthDashboardRoute,
  } as any)
const AppAuthDashboardOrganizationRoute =
  AppAuthDashboardOrganizationRouteImport.update({
    id: '/organization',
    path: '/organization',
    getParentRoute: () => AppAuthDashboardRoute,
  } as any)
const AppAuthDashboardGeneratorRoute =
  AppAuthDashboardGeneratorRouteImport.update({
    id: '/generator',
    path: '/generator',
    getParentRoute: () => AppAuthDashboardRoute,
  } as any)
const AppAuthDashboardFamilyRoute = AppAuthDashboardFamilyRouteImport.update({
  id: '/family',
  path: '/family',
  getParentRoute: () => AppAuthDashboardRoute,
} as any)
const AppAuthDashboardSettingsIndexRoute =
  AppAuthDashboardSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAuthDashboardSettingsRoute,
  } as any)
const AppAuthDashboardExtensionsIndexRoute =
  AppAuthDashboardExtensionsIndexRouteImport.update({
    id: '/extensions/',
    path: '/extensions/',
    getParentRoute: () => AppAuthDashboardRoute,
  } as any)
const AppAuthDashboardSettingsSecurityRoute =
  AppAuthDashboardSettingsSecurityRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => AppAuthDashboardSettingsRoute,
  } as any)
const AppAuthDashboardSettingsRemindersRoute =
  AppAuthDashboardSettingsRemindersRouteImport.update({
    id: '/reminders',
    path: '/reminders',
    getParentRoute: () => AppAuthDashboardSettingsRoute,
  } as any)
const AppAuthDashboardSettingsProfileRoute =
  AppAuthDashboardSettingsProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => AppAuthDashboardSettingsRoute,
  } as any)
const AppAuthDashboardSettingsPasswordHistoryRoute =
  AppAuthDashboardSettingsPasswordHistoryRouteImport.update({
    id: '/password-history',
    path: '/password-history',
    getParentRoute: () => AppAuthDashboardSettingsRoute,
  } as any)
const AppAuthDashboardSettingsImportExportRoute =
  AppAuthDashboardSettingsImportExportRouteImport.update({
    id: '/import-export',
    path: '/import-export',
    getParentRoute: () => AppAuthDashboardSettingsRoute,
  } as any)
const AppAuthDashboardSettingsEmergencyRoute =
  AppAuthDashboardSettingsEmergencyRouteImport.update({
    id: '/emergency',
    path: '/emergency',
    getParentRoute: () => AppAuthDashboardSettingsRoute,
  } as any)
const AppAuthDashboardSettingsDataExportRoute =
  AppAuthDashboardSettingsDataExportRouteImport.update({
    id: '/data-export',
    path: '/data-export',
    getParentRoute: () => AppAuthDashboardSettingsRoute,
  } as any)
const AppAuthDashboardSettingsBillingRoute =
  AppAuthDashboardSettingsBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AppAuthDashboardSettingsRoute,
  } as any)
const AppAuthDashboardExtensionsPairRoute =
  AppAuthDashboardExtensionsPairRouteImport.update({
    id: '/extensions/pair',
    path: '/extensions/pair',
    getParentRoute: () => AppAuthDashboardRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/faq': typeof FaqRoute
  '/features': typeof FeaturesRoute
  '/invitation': typeof InvitationRoute
  '/privacy': typeof PrivacyRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/security': typeof SecurityRoute
  '/superadmin': typeof SuperadminRouteWithChildren
  '/terms': typeof TermsRoute
  '/vs-1password': typeof Vs1passwordRoute
  '/vs-bitwarden': typeof VsBitwardenRoute
  '/vs-dashlane': typeof VsDashlaneRoute
  '/vs-lastpass': typeof VsLastpassRoute
  '/register': typeof AppRegisterRoute
  '/reset-password': typeof AppResetPasswordRoute
  '/invite/$token': typeof InviteTokenRoute
  '/share/$linkId': typeof ShareLinkIdRoute
  '/superadmin/ai-imports': typeof SuperadminAiImportsRoute
  '/superadmin/audit-logs': typeof SuperadminAuditLogsRoute
  '/superadmin/billing': typeof SuperadminBillingRoute
  '/superadmin/feature-flags': typeof SuperadminFeatureFlagsRoute
  '/superadmin/invitations': typeof SuperadminInvitationsRoute
  '/superadmin/legal': typeof SuperadminLegalRoute
  '/superadmin/notifications': typeof SuperadminNotificationsRoute
  '/superadmin/organizations': typeof SuperadminOrganizationsRoute
  '/superadmin/security': typeof SuperadminSecurityRoute
  '/superadmin/system': typeof SuperadminSystemRoute
  '/superadmin/users': typeof SuperadminUsersRoute
  '/superadmin/': typeof SuperadminIndexRoute
  '/dashboard': typeof AppAuthDashboardRouteWithChildren
  '/login': typeof AppLoginLayoutRouteWithChildren
  '/dashboard/family': typeof AppAuthDashboardFamilyRoute
  '/dashboard/generator': typeof AppAuthDashboardGeneratorRoute
  '/dashboard/organization': typeof AppAuthDashboardOrganizationRoute
  '/dashboard/settings': typeof AppAuthDashboardSettingsRouteWithChildren
  '/dashboard/vault': typeof AppAuthDashboardVaultRoute
  '/dashboard/watchtower': typeof AppAuthDashboardWatchtowerRoute
  '/dashboard/': typeof AppAuthDashboardIndexRoute
  '/login/': typeof AppLoginLayoutIndexRoute
  '/dashboard/extensions/pair': typeof AppAuthDashboardExtensionsPairRoute
  '/dashboard/settings/billing': typeof AppAuthDashboardSettingsBillingRoute
  '/dashboard/settings/data-export': typeof AppAuthDashboardSettingsDataExportRoute
  '/dashboard/settings/emergency': typeof AppAuthDashboardSettingsEmergencyRoute
  '/dashboard/settings/import-export': typeof AppAuthDashboardSettingsImportExportRoute
  '/dashboard/settings/password-history': typeof AppAuthDashboardSettingsPasswordHistoryRoute
  '/dashboard/settings/profile': typeof AppAuthDashboardSettingsProfileRoute
  '/dashboard/settings/reminders': typeof AppAuthDashboardSettingsRemindersRoute
  '/dashboard/settings/security': typeof AppAuthDashboardSettingsSecurityRoute
  '/dashboard/extensions/': typeof AppAuthDashboardExtensionsIndexRoute
  '/dashboard/settings/': typeof AppAuthDashboardSettingsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/faq': typeof FaqRoute
  '/features': typeof FeaturesRoute
  '/invitation': typeof InvitationRoute
  '/privacy': typeof PrivacyRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/security': typeof SecurityRoute
  '/terms': typeof TermsRoute
  '/vs-1password': typeof Vs1passwordRoute
  '/vs-bitwarden': typeof VsBitwardenRoute
  '/vs-dashlane': typeof VsDashlaneRoute
  '/vs-lastpass': typeof VsLastpassRoute
  '/register': typeof AppRegisterRoute
  '/reset-password': typeof AppResetPasswordRoute
  '/invite/$token': typeof InviteTokenRoute
  '/share/$linkId': typeof ShareLinkIdRoute
  '/superadmin/ai-imports': typeof SuperadminAiImportsRoute
  '/superadmin/audit-logs': typeof SuperadminAuditLogsRoute
  '/superadmin/billing': typeof SuperadminBillingRoute
  '/superadmin/feature-flags': typeof SuperadminFeatureFlagsRoute
  '/superadmin/invitations': typeof SuperadminInvitationsRoute
  '/superadmin/legal': typeof SuperadminLegalRoute
  '/superadmin/notifications': typeof SuperadminNotificationsRoute
  '/superadmin/organizations': typeof SuperadminOrganizationsRoute
  '/superadmin/security': typeof SuperadminSecurityRoute
  '/superadmin/system': typeof SuperadminSystemRoute
  '/superadmin/users': typeof SuperadminUsersRoute
  '/superadmin': typeof SuperadminIndexRoute
  '/dashboard/family': typeof AppAuthDashboardFamilyRoute
  '/dashboard/generator': typeof AppAuthDashboardGeneratorRoute
  '/dashboard/organization': typeof AppAuthDashboardOrganizationRoute
  '/dashboard/vault': typeof AppAuthDashboardVaultRoute
  '/dashboard/watchtower': typeof AppAuthDashboardWatchtowerRoute
  '/dashboard': typeof AppAuthDashboardIndexRoute
  '/login': typeof AppLoginLayoutIndexRoute
  '/dashboard/extensions/pair': typeof AppAuthDashboardExtensionsPairRoute
  '/dashboard/settings/billing': typeof AppAuthDashboardSettingsBillingRoute
  '/dashboard/settings/data-export': typeof AppAuthDashboardSettingsDataExportRoute
  '/dashboard/settings/emergency': typeof AppAuthDashboardSettingsEmergencyRoute
  '/dashboard/settings/import-export': typeof AppAuthDashboardSettingsImportExportRoute
  '/dashboard/settings/password-history': typeof AppAuthDashboardSettingsPasswordHistoryRoute
  '/dashboard/settings/profile': typeof AppAuthDashboardSettingsProfileRoute
  '/dashboard/settings/reminders': typeof AppAuthDashboardSettingsRemindersRoute
  '/dashboard/settings/security': typeof AppAuthDashboardSettingsSecurityRoute
  '/dashboard/extensions': typeof AppAuthDashboardExtensionsIndexRoute
  '/dashboard/settings': typeof AppAuthDashboardSettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/faq': typeof FaqRoute
  '/features': typeof FeaturesRoute
  '/invitation': typeof InvitationRoute
  '/privacy': typeof PrivacyRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/security': typeof SecurityRoute
  '/superadmin': typeof SuperadminRouteWithChildren
  '/terms': typeof TermsRoute
  '/vs-1password': typeof Vs1passwordRoute
  '/vs-bitwarden': typeof VsBitwardenRoute
  '/vs-dashlane': typeof VsDashlaneRoute
  '/vs-lastpass': typeof VsLastpassRoute
  '/_app/_auth': typeof AppAuthRouteWithChildren
  '/_app/register': typeof AppRegisterRoute
  '/_app/reset-password': typeof AppResetPasswordRoute
  '/invite/$token': typeof InviteTokenRoute
  '/share/$linkId': typeof ShareLinkIdRoute
  '/superadmin/ai-imports': typeof SuperadminAiImportsRoute
  '/superadmin/audit-logs': typeof SuperadminAuditLogsRoute
  '/superadmin/billing': typeof SuperadminBillingRoute
  '/superadmin/feature-flags': typeof SuperadminFeatureFlagsRoute
  '/superadmin/invitations': typeof SuperadminInvitationsRoute
  '/superadmin/legal': typeof SuperadminLegalRoute
  '/superadmin/notifications': typeof SuperadminNotificationsRoute
  '/superadmin/organizations': typeof SuperadminOrganizationsRoute
  '/superadmin/security': typeof SuperadminSecurityRoute
  '/superadmin/system': typeof SuperadminSystemRoute
  '/superadmin/users': typeof SuperadminUsersRoute
  '/superadmin/': typeof SuperadminIndexRoute
  '/_app/_auth/dashboard': typeof AppAuthDashboardRouteWithChildren
  '/_app/login/_layout': typeof AppLoginLayoutRouteWithChildren
  '/_app/_auth/dashboard/family': typeof AppAuthDashboardFamilyRoute
  '/_app/_auth/dashboard/generator': typeof AppAuthDashboardGeneratorRoute
  '/_app/_auth/dashboard/organization': typeof AppAuthDashboardOrganizationRoute
  '/_app/_auth/dashboard/settings': typeof AppAuthDashboardSettingsRouteWithChildren
  '/_app/_auth/dashboard/vault': typeof AppAuthDashboardVaultRoute
  '/_app/_auth/dashboard/watchtower': typeof AppAuthDashboardWatchtowerRoute
  '/_app/_auth/dashboard/': typeof AppAuthDashboardIndexRoute
  '/_app/login/_layout/': typeof AppLoginLayoutIndexRoute
  '/_app/_auth/dashboard/extensions/pair': typeof AppAuthDashboardExtensionsPairRoute
  '/_app/_auth/dashboard/settings/billing': typeof AppAuthDashboardSettingsBillingRoute
  '/_app/_auth/dashboard/settings/data-export': typeof AppAuthDashboardSettingsDataExportRoute
  '/_app/_auth/dashboard/settings/emergency': typeof AppAuthDashboardSettingsEmergencyRoute
  '/_app/_auth/dashboard/settings/import-export': typeof AppAuthDashboardSettingsImportExportRoute
  '/_app/_auth/dashboard/settings/password-history': typeof AppAuthDashboardSettingsPasswordHistoryRoute
  '/_app/_auth/dashboard/settings/profile': typeof AppAuthDashboardSettingsProfileRoute
  '/_app/_auth/dashboard/settings/reminders': typeof AppAuthDashboardSettingsRemindersRoute
  '/_app/_auth/dashboard/settings/security': typeof AppAuthDashboardSettingsSecurityRoute
  '/_app/_auth/dashboard/extensions/': typeof AppAuthDashboardExtensionsIndexRoute
  '/_app/_auth/dashboard/settings/': typeof AppAuthDashboardSettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/faq'
    | '/features'
    | '/invitation'
    | '/privacy'
    | '/privacy-policy'
    | '/security'
    | '/superadmin'
    | '/terms'
    | '/vs-1password'
    | '/vs-bitwarden'
    | '/vs-dashlane'
    | '/vs-lastpass'
    | '/register'
    | '/reset-password'
    | '/invite/$token'
    | '/share/$linkId'
    | '/superadmin/ai-imports'
    | '/superadmin/audit-logs'
    | '/superadmin/billing'
    | '/superadmin/feature-flags'
    | '/superadmin/invitations'
    | '/superadmin/legal'
    | '/superadmin/notifications'
    | '/superadmin/organizations'
    | '/superadmin/security'
    | '/superadmin/system'
    | '/superadmin/users'
    | '/superadmin/'
    | '/dashboard'
    | '/login'
    | '/dashboard/family'
    | '/dashboard/generator'
    | '/dashboard/organization'
    | '/dashboard/settings'
    | '/dashboard/vault'
    | '/dashboard/watchtower'
    | '/dashboard/'
    | '/login/'
    | '/dashboard/extensions/pair'
    | '/dashboard/settings/billing'
    | '/dashboard/settings/data-export'
    | '/dashboard/settings/emergency'
    | '/dashboard/settings/import-export'
    | '/dashboard/settings/password-history'
    | '/dashboard/settings/profile'
    | '/dashboard/settings/reminders'
    | '/dashboard/settings/security'
    | '/dashboard/extensions/'
    | '/dashboard/settings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/faq'
    | '/features'
    | '/invitation'
    | '/privacy'
    | '/privacy-policy'
    | '/security'
    | '/terms'
    | '/vs-1password'
    | '/vs-bitwarden'
    | '/vs-dashlane'
    | '/vs-lastpass'
    | '/register'
    | '/reset-password'
    | '/invite/$token'
    | '/share/$linkId'
    | '/superadmin/ai-imports'
    | '/superadmin/audit-logs'
    | '/superadmin/billing'
    | '/superadmin/feature-flags'
    | '/superadmin/invitations'
    | '/superadmin/legal'
    | '/superadmin/notifications'
    | '/superadmin/organizations'
    | '/superadmin/security'
    | '/superadmin/system'
    | '/superadmin/users'
    | '/superadmin'
    | '/dashboard/family'
    | '/dashboard/generator'
    | '/dashboard/organization'
    | '/dashboard/vault'
    | '/dashboard/watchtower'
    | '/dashboard'
    | '/login'
    | '/dashboard/extensions/pair'
    | '/dashboard/settings/billing'
    | '/dashboard/settings/data-export'
    | '/dashboard/settings/emergency'
    | '/dashboard/settings/import-export'
    | '/dashboard/settings/password-history'
    | '/dashboard/settings/profile'
    | '/dashboard/settings/reminders'
    | '/dashboard/settings/security'
    | '/dashboard/extensions'
    | '/dashboard/settings'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/faq'
    | '/features'
    | '/invitation'
    | '/privacy'
    | '/privacy-policy'
    | '/security'
    | '/superadmin'
    | '/terms'
    | '/vs-1password'
    | '/vs-bitwarden'
    | '/vs-dashlane'
    | '/vs-lastpass'
    | '/_app/_auth'
    | '/_app/register'
    | '/_app/reset-password'
    | '/invite/$token'
    | '/share/$linkId'
    | '/superadmin/ai-imports'
    | '/superadmin/audit-logs'
    | '/superadmin/billing'
    | '/superadmin/feature-flags'
    | '/superadmin/invitations'
    | '/superadmin/legal'
    | '/superadmin/notifications'
    | '/superadmin/organizations'
    | '/superadmin/security'
    | '/superadmin/system'
    | '/superadmin/users'
    | '/superadmin/'
    | '/_app/_auth/dashboard'
    | '/_app/login/_layout'
    | '/_app/_auth/dashboard/family'
    | '/_app/_auth/dashboard/generator'
    | '/_app/_auth/dashboard/organization'
    | '/_app/_auth/dashboard/settings'
    | '/_app/_auth/dashboard/vault'
    | '/_app/_auth/dashboard/watchtower'
    | '/_app/_auth/dashboard/'
    | '/_app/login/_layout/'
    | '/_app/_auth/dashboard/extensions/pair'
    | '/_app/_auth/dashboard/settings/billing'
    | '/_app/_auth/dashboard/settings/data-export'
    | '/_app/_auth/dashboard/settings/emergency'
    | '/_app/_auth/dashboard/settings/import-export'
    | '/_app/_auth/dashboard/settings/password-history'
    | '/_app/_auth/dashboard/settings/profile'
    | '/_app/_auth/dashboard/settings/reminders'
    | '/_app/_auth/dashboard/settings/security'
    | '/_app/_auth/dashboard/extensions/'
    | '/_app/_auth/dashboard/settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  FaqRoute: typeof FaqRoute
  FeaturesRoute: typeof FeaturesRoute
  InvitationRoute: typeof InvitationRoute
  PrivacyRoute: typeof PrivacyRoute
  PrivacyPolicyRoute: typeof PrivacyPolicyRoute
  SecurityRoute: typeof SecurityRoute
  SuperadminRoute: typeof SuperadminRouteWithChildren
  TermsRoute: typeof TermsRoute
  Vs1passwordRoute: typeof Vs1passwordRoute
  VsBitwardenRoute: typeof VsBitwardenRoute
  VsDashlaneRoute: typeof VsDashlaneRoute
  VsLastpassRoute: typeof VsLastpassRoute
  InviteTokenRoute: typeof InviteTokenRoute
  ShareLinkIdRoute: typeof ShareLinkIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/vs-lastpass': {
      id: '/vs-lastpass'
      path: '/vs-lastpass'
      fullPath: '/vs-lastpass'
      preLoaderRoute: typeof VsLastpassRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vs-dashlane': {
      id: '/vs-dashlane'
      path: '/vs-dashlane'
      fullPath: '/vs-dashlane'
      preLoaderRoute: typeof VsDashlaneRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vs-bitwarden': {
      id: '/vs-bitwarden'
      path: '/vs-bitwarden'
      fullPath: '/vs-bitwarden'
      preLoaderRoute: typeof VsBitwardenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vs-1password': {
      id: '/vs-1password'
      path: '/vs-1password'
      fullPath: '/vs-1password'
      preLoaderRoute: typeof Vs1passwordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/superadmin': {
      id: '/superadmin'
      path: '/superadmin'
      fullPath: '/superadmin'
      preLoaderRoute: typeof SuperadminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/security': {
      id: '/security'
      path: '/security'
      fullPath: '/security'
      preLoaderRoute: typeof SecurityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy-policy': {
      id: '/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PrivacyPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invitation': {
      id: '/invitation'
      path: '/invitation'
      fullPath: '/invitation'
      preLoaderRoute: typeof InvitationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/features': {
      id: '/features'
      path: '/features'
      fullPath: '/features'
      preLoaderRoute: typeof FeaturesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/faq': {
      id: '/faq'
      path: '/faq'
      fullPath: '/faq'
      preLoaderRoute: typeof FaqRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/superadmin/': {
      id: '/superadmin/'
      path: '/'
      fullPath: '/superadmin/'
      preLoaderRoute: typeof SuperadminIndexRouteImport
      parentRoute: typeof SuperadminRoute
    }
    '/superadmin/users': {
      id: '/superadmin/users'
      path: '/users'
      fullPath: '/superadmin/users'
      preLoaderRoute: typeof SuperadminUsersRouteImport
      parentRoute: typeof SuperadminRoute
    }
    '/superadmin/system': {
      id: '/superadmin/system'
      path: '/system'
      fullPath: '/superadmin/system'
      preLoaderRoute: typeof SuperadminSystemRouteImport
      parentRoute: typeof SuperadminRoute
    }
    '/superadmin/security': {
      id: '/superadmin/security'
      path: '/security'
      fullPath: '/superadmin/security'
      preLoaderRoute: typeof SuperadminSecurityRouteImport
      parentRoute: typeof SuperadminRoute
    }
    '/superadmin/organizations': {
      id: '/superadmin/organizations'
      path: '/organizations'
      fullPath: '/superadmin/organizations'
      preLoaderRoute: typeof SuperadminOrganizationsRouteImport
      parentRoute: typeof SuperadminRoute
    }
    '/superadmin/notifications': {
      id: '/superadmin/notifications'
      path: '/notifications'
      fullPath: '/superadmin/notifications'
      preLoaderRoute: typeof SuperadminNotificationsRouteImport
      parentRoute: typeof SuperadminRoute
    }
    '/superadmin/legal': {
      id: '/superadmin/legal'
      path: '/legal'
      fullPath: '/superadmin/legal'
      preLoaderRoute: typeof SuperadminLegalRouteImport
      parentRoute: typeof SuperadminRoute
    }
    '/superadmin/invitations': {
      id: '/superadmin/invitations'
      path: '/invitations'
      fullPath: '/superadmin/invitations'
      preLoaderRoute: typeof SuperadminInvitationsRouteImport
      parentRoute: typeof SuperadminRoute
    }
    '/superadmin/feature-flags': {
      id: '/superadmin/feature-flags'
      path: '/feature-flags'
      fullPath: '/superadmin/feature-flags'
      preLoaderRoute: typeof SuperadminFeatureFlagsRouteImport
      parentRoute: typeof SuperadminRoute
    }
    '/superadmin/billing': {
      id: '/superadmin/billing'
      path: '/billing'
      fullPath: '/superadmin/billing'
      preLoaderRoute: typeof SuperadminBillingRouteImport
      parentRoute: typeof SuperadminRoute
    }
    '/superadmin/audit-logs': {
      id: '/superadmin/audit-logs'
      path: '/audit-logs'
      fullPath: '/superadmin/audit-logs'
      preLoaderRoute: typeof SuperadminAuditLogsRouteImport
      parentRoute: typeof SuperadminRoute
    }
    '/superadmin/ai-imports': {
      id: '/superadmin/ai-imports'
      path: '/ai-imports'
      fullPath: '/superadmin/ai-imports'
      preLoaderRoute: typeof SuperadminAiImportsRouteImport
      parentRoute: typeof SuperadminRoute
    }
    '/share/$linkId': {
      id: '/share/$linkId'
      path: '/share/$linkId'
      fullPath: '/share/$linkId'
      preLoaderRoute: typeof ShareLinkIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/reset-password': {
      id: '/_app/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AppResetPasswordRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/register': {
      id: '/_app/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof AppRegisterRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_auth': {
      id: '/_app/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppAuthRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/login/_layout': {
      id: '/_app/login/_layout'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AppLoginLayoutRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_auth/dashboard': {
      id: '/_app/_auth/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppAuthDashboardRouteImport
      parentRoute: typeof AppAuthRoute
    }
    '/_app/login/_layout/': {
      id: '/_app/login/_layout/'
      path: '/'
      fullPath: '/login/'
      preLoaderRoute: typeof AppLoginLayoutIndexRouteImport
      parentRoute: typeof AppLoginLayoutRoute
    }
    '/_app/_auth/dashboard/': {
      id: '/_app/_auth/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof AppAuthDashboardIndexRouteImport
      parentRoute: typeof AppAuthDashboardRoute
    }
    '/_app/_auth/dashboard/watchtower': {
      id: '/_app/_auth/dashboard/watchtower'
      path: '/watchtower'
      fullPath: '/dashboard/watchtower'
      preLoaderRoute: typeof AppAuthDashboardWatchtowerRouteImport
      parentRoute: typeof AppAuthDashboardRoute
    }
    '/_app/_auth/dashboard/vault': {
      id: '/_app/_auth/dashboard/vault'
      path: '/vault'
      fullPath: '/dashboard/vault'
      preLoaderRoute: typeof AppAuthDashboardVaultRouteImport
      parentRoute: typeof AppAuthDashboardRoute
    }
    '/_app/_auth/dashboard/settings': {
      id: '/_app/_auth/dashboard/settings'
      path: '/settings'
      fullPath: '/dashboard/settings'
      preLoaderRoute: typeof AppAuthDashboardSettingsRouteImport
      parentRoute: typeof AppAuthDashboardRoute
    }
    '/_app/_auth/dashboard/organization': {
      id: '/_app/_auth/dashboard/organization'
      path: '/organization'
      fullPath: '/dashboard/organization'
      preLoaderRoute: typeof AppAuthDashboardOrganizationRouteImport
      parentRoute: typeof AppAuthDashboardRoute
    }
    '/_app/_auth/dashboard/generator': {
      id: '/_app/_auth/dashboard/generator'
      path: '/generator'
      fullPath: '/dashboard/generator'
      preLoaderRoute: typeof AppAuthDashboardGeneratorRouteImport
      parentRoute: typeof AppAuthDashboardRoute
    }
    '/_app/_auth/dashboard/family': {
      id: '/_app/_auth/dashboard/family'
      path: '/family'
      fullPath: '/dashboard/family'
      preLoaderRoute: typeof AppAuthDashboardFamilyRouteImport
      parentRoute: typeof AppAuthDashboardRoute
    }
    '/_app/_auth/dashboard/settings/': {
      id: '/_app/_auth/dashboard/settings/'
      path: '/'
      fullPath: '/dashboard/settings/'
      preLoaderRoute: typeof AppAuthDashboardSettingsIndexRouteImport
      parentRoute: typeof AppAuthDashboardSettingsRoute
    }
    '/_app/_auth/dashboard/extensions/': {
      id: '/_app/_auth/dashboard/extensions/'
      path: '/extensions'
      fullPath: '/dashboard/extensions/'
      preLoaderRoute: typeof AppAuthDashboardExtensionsIndexRouteImport
      parentRoute: typeof AppAuthDashboardRoute
    }
    '/_app/_auth/dashboard/settings/security': {
      id: '/_app/_auth/dashboard/settings/security'
      path: '/security'
      fullPath: '/dashboard/settings/security'
      preLoaderRoute: typeof AppAuthDashboardSettingsSecurityRouteImport
      parentRoute: typeof AppAuthDashboardSettingsRoute
    }
    '/_app/_auth/dashboard/settings/reminders': {
      id: '/_app/_auth/dashboard/settings/reminders'
      path: '/reminders'
      fullPath: '/dashboard/settings/reminders'
      preLoaderRoute: typeof AppAuthDashboardSettingsRemindersRouteImport
      parentRoute: typeof AppAuthDashboardSettingsRoute
    }
    '/_app/_auth/dashboard/settings/profile': {
      id: '/_app/_auth/dashboard/settings/profile'
      path: '/profile'
      fullPath: '/dashboard/settings/profile'
      preLoaderRoute: typeof AppAuthDashboardSettingsProfileRouteImport
      parentRoute: typeof AppAuthDashboardSettingsRoute
    }
    '/_app/_auth/dashboard/settings/password-history': {
      id: '/_app/_auth/dashboard/settings/password-history'
      path: '/password-history'
      fullPath: '/dashboard/settings/password-history'
      preLoaderRoute: typeof AppAuthDashboardSettingsPasswordHistoryRouteImport
      parentRoute: typeof AppAuthDashboardSettingsRoute
    }
    '/_app/_auth/dashboard/settings/import-export': {
      id: '/_app/_auth/dashboard/settings/import-export'
      path: '/import-export'
      fullPath: '/dashboard/settings/import-export'
      preLoaderRoute: typeof AppAuthDashboardSettingsImportExportRouteImport
      parentRoute: typeof AppAuthDashboardSettingsRoute
    }
    '/_app/_auth/dashboard/settings/emergency': {
      id: '/_app/_auth/dashboard/settings/emergency'
      path: '/emergency'
      fullPath: '/dashboard/settings/emergency'
      preLoaderRoute: typeof AppAuthDashboardSettingsEmergencyRouteImport
      parentRoute: typeof AppAuthDashboardSettingsRoute
    }
    '/_app/_auth/dashboard/settings/data-export': {
      id: '/_app/_auth/dashboard/settings/data-export'
      path: '/data-export'
      fullPath: '/dashboard/settings/data-export'
      preLoaderRoute: typeof AppAuthDashboardSettingsDataExportRouteImport
      parentRoute: typeof AppAuthDashboardSettingsRoute
    }
    '/_app/_auth/dashboard/settings/billing': {
      id: '/_app/_auth/dashboard/settings/billing'
      path: '/billing'
      fullPath: '/dashboard/settings/billing'
      preLoaderRoute: typeof AppAuthDashboardSettingsBillingRouteImport
      parentRoute: typeof AppAuthDashboardSettingsRoute
    }
    '/_app/_auth/dashboard/extensions/pair': {
      id: '/_app/_auth/dashboard/extensions/pair'
      path: '/extensions/pair'
      fullPath: '/dashboard/extensions/pair'
      preLoaderRoute: typeof AppAuthDashboardExtensionsPairRouteImport
      parentRoute: typeof AppAuthDashboardRoute
    }
  }
}

interface AppAuthDashboardSettingsRouteChildren {
  AppAuthDashboardSettingsBillingRoute: typeof AppAuthDashboardSettingsBillingRoute
  AppAuthDashboardSettingsDataExportRoute: typeof AppAuthDashboardSettingsDataExportRoute
  AppAuthDashboardSettingsEmergencyRoute: typeof AppAuthDashboardSettingsEmergencyRoute
  AppAuthDashboardSettingsImportExportRoute: typeof AppAuthDashboardSettingsImportExportRoute
  AppAuthDashboardSettingsPasswordHistoryRoute: typeof AppAuthDashboardSettingsPasswordHistoryRoute
  AppAuthDashboardSettingsProfileRoute: typeof AppAuthDashboardSettingsProfileRoute
  AppAuthDashboardSettingsRemindersRoute: typeof AppAuthDashboardSettingsRemindersRoute
  AppAuthDashboardSettingsSecurityRoute: typeof AppAuthDashboardSettingsSecurityRoute
  AppAuthDashboardSettingsIndexRoute: typeof AppAuthDashboardSettingsIndexRoute
}

const AppAuthDashboardSettingsRouteChildren: AppAuthDashboardSettingsRouteChildren =
  {
    AppAuthDashboardSettingsBillingRoute: AppAuthDashboardSettingsBillingRoute,
    AppAuthDashboardSettingsDataExportRoute:
      AppAuthDashboardSettingsDataExportRoute,
    AppAuthDashboardSettingsEmergencyRoute:
      AppAuthDashboardSettingsEmergencyRoute,
    AppAuthDashboardSettingsImportExportRoute:
      AppAuthDashboardSettingsImportExportRoute,
    AppAuthDashboardSettingsPasswordHistoryRoute:
      AppAuthDashboardSettingsPasswordHistoryRoute,
    AppAuthDashboardSettingsProfileRoute: AppAuthDashboardSettingsProfileRoute,
    AppAuthDashboardSettingsRemindersRoute:
      AppAuthDashboardSettingsRemindersRoute,
    AppAuthDashboardSettingsSecurityRoute:
      AppAuthDashboardSettingsSecurityRoute,
    AppAuthDashboardSettingsIndexRoute: AppAuthDashboardSettingsIndexRoute,
  }

const AppAuthDashboardSettingsRouteWithChildren =
  AppAuthDashboardSettingsRoute._addFileChildren(
    AppAuthDashboardSettingsRouteChildren,
  )

interface AppAuthDashboardRouteChildren {
  AppAuthDashboardFamilyRoute: typeof AppAuthDashboardFamilyRoute
  AppAuthDashboardGeneratorRoute: typeof AppAuthDashboardGeneratorRoute
  AppAuthDashboardOrganizationRoute: typeof AppAuthDashboardOrganizationRoute
  AppAuthDashboardSettingsRoute: typeof AppAuthDashboardSettingsRouteWithChildren
  AppAuthDashboardVaultRoute: typeof AppAuthDashboardVaultRoute
  AppAuthDashboardWatchtowerRoute: typeof AppAuthDashboardWatchtowerRoute
  AppAuthDashboardIndexRoute: typeof AppAuthDashboardIndexRoute
  AppAuthDashboardExtensionsPairRoute: typeof AppAuthDashboardExtensionsPairRoute
  AppAuthDashboardExtensionsIndexRoute: typeof AppAuthDashboardExtensionsIndexRoute
}

const AppAuthDashboardRouteChildren: AppAuthDashboardRouteChildren = {
  AppAuthDashboardFamilyRoute: AppAuthDashboardFamilyRoute,
  AppAuthDashboardGeneratorRoute: AppAuthDashboardGeneratorRoute,
  AppAuthDashboardOrganizationRoute: AppAuthDashboardOrganizationRoute,
  AppAuthDashboardSettingsRoute: AppAuthDashboardSettingsRouteWithChildren,
  AppAuthDashboardVaultRoute: AppAuthDashboardVaultRoute,
  AppAuthDashboardWatchtowerRoute: AppAuthDashboardWatchtowerRoute,
  AppAuthDashboardIndexRoute: AppAuthDashboardIndexRoute,
  AppAuthDashboardExtensionsPairRoute: AppAuthDashboardExtensionsPairRoute,
  AppAuthDashboardExtensionsIndexRoute: AppAuthDashboardExtensionsIndexRoute,
}

const AppAuthDashboardRouteWithChildren =
  AppAuthDashboardRoute._addFileChildren(AppAuthDashboardRouteChildren)

interface AppAuthRouteChildren {
  AppAuthDashboardRoute: typeof AppAuthDashboardRouteWithChildren
}

const AppAuthRouteChildren: AppAuthRouteChildren = {
  AppAuthDashboardRoute: AppAuthDashboardRouteWithChildren,
}

const AppAuthRouteWithChildren =
  AppAuthRoute._addFileChildren(AppAuthRouteChildren)

interface AppLoginLayoutRouteChildren {
  AppLoginLayoutIndexRoute: typeof AppLoginLayoutIndexRoute
}

const AppLoginLayoutRouteChildren: AppLoginLayoutRouteChildren = {
  AppLoginLayoutIndexRoute: AppLoginLayoutIndexRoute,
}

const AppLoginLayoutRouteWithChildren = AppLoginLayoutRoute._addFileChildren(
  AppLoginLayoutRouteChildren,
)

interface AppRouteChildren {
  AppAuthRoute: typeof AppAuthRouteWithChildren
  AppRegisterRoute: typeof AppRegisterRoute
  AppResetPasswordRoute: typeof AppResetPasswordRoute
  AppLoginLayoutRoute: typeof AppLoginLayoutRouteWithChildren
}

const AppRouteChildren: AppRouteChildren = {
  AppAuthRoute: AppAuthRouteWithChildren,
  AppRegisterRoute: AppRegisterRoute,
  AppResetPasswordRoute: AppResetPasswordRoute,
  AppLoginLayoutRoute: AppLoginLayoutRouteWithChildren,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface SuperadminRouteChildren {
  SuperadminAiImportsRoute: typeof SuperadminAiImportsRoute
  SuperadminAuditLogsRoute: typeof SuperadminAuditLogsRoute
  SuperadminBillingRoute: typeof SuperadminBillingRoute
  SuperadminFeatureFlagsRoute: typeof SuperadminFeatureFlagsRoute
  SuperadminInvitationsRoute: typeof SuperadminInvitationsRoute
  SuperadminLegalRoute: typeof SuperadminLegalRoute
  SuperadminNotificationsRoute: typeof SuperadminNotificationsRoute
  SuperadminOrganizationsRoute: typeof SuperadminOrganizationsRoute
  SuperadminSecurityRoute: typeof SuperadminSecurityRoute
  SuperadminSystemRoute: typeof SuperadminSystemRoute
  SuperadminUsersRoute: typeof SuperadminUsersRoute
  SuperadminIndexRoute: typeof SuperadminIndexRoute
}

const SuperadminRouteChildren: SuperadminRouteChildren = {
  SuperadminAiImportsRoute: SuperadminAiImportsRoute,
  SuperadminAuditLogsRoute: SuperadminAuditLogsRoute,
  SuperadminBillingRoute: SuperadminBillingRoute,
  SuperadminFeatureFlagsRoute: SuperadminFeatureFlagsRoute,
  SuperadminInvitationsRoute: SuperadminInvitationsRoute,
  SuperadminLegalRoute: SuperadminLegalRoute,
  SuperadminNotificationsRoute: SuperadminNotificationsRoute,
  SuperadminOrganizationsRoute: SuperadminOrganizationsRoute,
  SuperadminSecurityRoute: SuperadminSecurityRoute,
  SuperadminSystemRoute: SuperadminSystemRoute,
  SuperadminUsersRoute: SuperadminUsersRoute,
  SuperadminIndexRoute: SuperadminIndexRoute,
}

const SuperadminRouteWithChildren = SuperadminRoute._addFileChildren(
  SuperadminRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  FaqRoute: FaqRoute,
  FeaturesRoute: FeaturesRoute,
  InvitationRoute: InvitationRoute,
  PrivacyRoute: PrivacyRoute,
  PrivacyPolicyRoute: PrivacyPolicyRoute,
  SecurityRoute: SecurityRoute,
  SuperadminRoute: SuperadminRouteWithChildren,
  TermsRoute: TermsRoute,
  Vs1passwordRoute: Vs1passwordRoute,
  VsBitwardenRoute: VsBitwardenRoute,
  VsDashlaneRoute: VsDashlaneRoute,
  VsLastpassRoute: VsLastpassRoute,
  InviteTokenRoute: InviteTokenRoute,
  ShareLinkIdRoute: ShareLinkIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
